

import React from "react";
import {MDBNavbar} from "mdbreact";
export default function Header() {
    return (
        <MDBNavbar
            color="light"
            dark
            expand="md"
            className="site-footer d-flex flex-column align-items-center fixed-bottom"
        >
             EIN Doc Pros is not affiliated with the IRS or the U.S.
                Government

        </MDBNavbar>
    );
}